import { getRelativeImagePath } from "util/helper/getRelativeImagePath";
import { filterableAttributeSpriteImages, nbcAttributeImages } from "../V2/image-section/image-helper";

const NbcFilterImage = (props) => {
  const {
    filterKey, filterValue, size = 80, hideCommonLabel = false,
  } = props;

  const getImageProperties = () => {
    const attributeArray = ["nbcTires", "wheelsFilterableAttribute"];
    let filterImgIndex = -1;
    let src = "";
    let arraySize = 0;
    attributeArray.forEach((spriteImgEl) => {
      const filterAttributeArray = filterableAttributeSpriteImages[spriteImgEl];
      const tiresAttributeIndex = filterAttributeArray?.findIndex((el) => {
        if (el === filterKey) {
          return true;
        }
        const prefix = ["tire", "wheel"];
        // console.log("map", filterKey, `${el.charAt(0).toUpperCase()}${el.slice(1, el.length - 1)}`);
        return prefix.some((prefixEl) => `${prefixEl}${el.charAt(0).toUpperCase()}${el.slice(1, el.length)}` === filterKey
         || `${prefixEl}${el.charAt(0).toUpperCase()}${el.slice(1, el.length - 1)}` === filterKey
         || `${prefixEl}${el.charAt(0).toUpperCase()}${el.slice(1, el.length - 2)}` === filterKey);
      });
      if (tiresAttributeIndex >= 0) {
        filterImgIndex = tiresAttributeIndex;
        src = getRelativeImagePath(`/cms/pubicImages/images/${nbcAttributeImages[spriteImgEl]}`);
        arraySize = filterAttributeArray.length;
      }
    });

    return { filterImgIndex, src, arraySize };
  };

  const { filterImgIndex, src, arraySize } = getImageProperties();

  if (filterImgIndex >= 0 && !hideCommonLabel) {
    return (
      <div
        style={{
          backgroundImage: `url(${src})`,
          backgroundPosition: `-${size * filterImgIndex}px calc(0 * var(--safari-root-font, 10px))`,
          width: `${size}px`,
          height: `${size}px`,
          backgroundSize: `${arraySize * size}px ${size}px`,
          backgroundRepeat: "no-repeat",
        }}
      />
    );
  }
  const attributeArray = filterableAttributeSpriteImages[filterKey];
  const index = attributeArray?.findIndex((el) => el === filterValue);
  const imgSrc = getRelativeImagePath(`/cms/pubicImages/images/${nbcAttributeImages[filterKey]}`);

  if (index >= 0) {
    return (
      <div
        style={{
          backgroundImage: `url(${imgSrc})`,
          backgroundPosition: `-${size * index}px calc(0 * var(--safari-root-font, 10px))`,
          width: `${size}px`,
          height: `${size}px`,
          backgroundSize: `${attributeArray?.length * size}px ${size}px`,
          backgroundRepeat: "no-repeat",

        }}
      />
    );
  }

  return null;
};

export default NbcFilterImage;
